import CreateAttributeRuleModal from './CreateAttributeRuleModal';

export default CreateAttributeRuleModal;
